// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    [
      {
        "sub": "证券投资实务",
        "tec": "隋庶",
        "week": "1-6周",
        "add": "实训楼E座417管理机房"
      },
      {
        "sub": "企业管理咨询",
        "tec": "郑新娜",
        "week": "7-10周",
        "add": "教学楼D座321文法"
      }
    ],
    {
      "sub": "大数据财务分析",
      "tec": "隋庶",
      "week": "1-8周",
      "add": "实训楼E座417管理机房"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "专业英语",
      "tec": "陈涵慧",
      "week": "1-10周",
      "add": "教学楼D座321文法"
    },
    [
      {
        "sub": "公司战略与风险管理",
        "tec": "郑新娜",
        "week": "1-8周",
        "add": "教学楼D座321文法"
      },
      {
        "sub": "企业管理咨询",
        "tec": "郑新娜",
        "week": "9-10周",
        "add": "教学楼D座321文法"
      }
    ],
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "管理会计",
      "tec": "隋志纯",
      "week": "1-10周",
      "add": "教学楼D座321文法"
    },
    {
      "sub": "证券投资实务",
      "tec": "隋庶",
      "week": "1-10周",
      "add": "实训楼E座417管理机房"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    [
      {
        "sub": "公司战略与风险管理",
        "tec": "郑新娜",
        "week": "1-8周",
        "add": "教学楼D座321文法"
      },
      {
        "sub": "企业管理咨询",
        "tec": "郑新娜",
        "week": "9-10周",
        "add": "教学楼D座321文法"
      }
    ],
    {
      "sub": "专业英语",
      "tec": "陈涵慧",
      "week": "1-6周",
      "add": "教学楼D座321文法"
    },
    0,
    0
  ],
  "5": [
    {
      "sub": "管理会计",
      "tec": "隋志纯",
      "week": "1-10周",
      "add": "教学楼D座321文法"
    },
    {
      "sub": "财务机器人",
      "tec": "隋庶",
      "week": "1-8周",
      "add": "实训楼E座417管理机房"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
